import React, {useState, useEffect, useMemo, useContext} from 'react';
import {Row, Col, Button} from 'reactstrap';
import {Formik, Field, Form} from 'formik';
import * as Sentry from '@sentry/react'
import {FetchResult, MutationFunctionOptions} from '@apollo/client';
import {ReturnValue} from 'use-timer/lib/types';
import {useIntl} from 'react-intl';
import Swal from 'sweetalert2';

import UserContext from '../contexts/user';

import getEncodedImageUrl from '../helpers/get-encoded-image'
// import UserContext from '../contexts/user';
import {CheckBox, CheckboxGroup} from '../helpers/formik';
import {Question} from '../types/quiz';

const QuizResultUserForm: React.FC<{
    question: Question;
    index: number;
    totalQuestions: number
    show_quiz: boolean;
    show_results: boolean;
    submit_answer: (options?: MutationFunctionOptions<any, Record<string, any>> | undefined) => Promise<FetchResult<any, Record<string, any>, Record<string, any>>>;
    timer: ReturnValue;
    setCurrentQuestion?: (q: Question | null) => void;
}> = ({
          question,
          index,
          totalQuestions,
          show_quiz,
          show_results,
          submit_answer,
          timer,
          setCurrentQuestion,
      }) => {
    const userContext = useContext(UserContext);
    const [submitting, setSubmitting] = useState(false);
    const initialValues: { [key: string]: boolean } = useMemo(() => ({}), []);
    const intl = useIntl();

    useEffect(() => {
        question.options.forEach((option) => {
            initialValues[`${question.id}#${option.id}`] = false;
        })
    }, [question.options, question.id, initialValues]);

    const {advanceTime, reset, start, pause} = timer;

    useEffect(() => {
        if (question.id && !question.is_survey && !show_results) {
            reset();
            start();
            advanceTime(JSON.parse(localStorage.getItem(`quiz-timer-${userContext.user?.id}-${question.id}`) || "0"));
            // setTimeout(() => {
            //   start();
            // }, 400);
        }
    }, [start, reset, advanceTime, show_results, question.id, question.is_survey, userContext.user]);


    useEffect(() => {
        if (question.id && setCurrentQuestion) {
            setCurrentQuestion(question);
            return () => {
                setCurrentQuestion(null);
            }
        }
    }, [setCurrentQuestion, question]);

    // timer
    useEffect(() => {
        //  console.log('debug: show_results: ', show_results);
        if (!show_results) {
            start();
        }
        return () => {
            // reset
            pause()
        }
    }, [question, show_results, start, pause])

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async values => {
                setSubmitting(true);
                //  console.log('debug:values:', values);
                const option_ids = Object.keys(values)
                    .filter((key) => values[key])
                    .map((key) => key.split('#')[1])

                if (option_ids.length === 0) {

                    Swal.fire({
                        title: 'Please select atlest one option and submit',
                        icon: 'error',
                    })
                    setSubmitting(false);
                    return;
                }

                try {
                    timer.pause();

                     console.log("debug-xxx requestData", question.id, option_ids, parseFloat(timer.time.toFixed(1)))
                    // await submit_answer({
                    //     variables: {
                    //         question_id: question.id,
                    //         option_ids,
                    //         time: parseFloat(timer.time.toFixed(1)),
                    //     }
                    // });


                } catch (e) {
                    //Sentry.captureException(e);
                     console.log('debug: submit_answer: error: ', e)
                    // Swal.fire({
                    //     title: 'There was an error while submitting your answer',
                    //     icon: 'error',
                    // })
                }

                
            }}
        >
            {() => {
                return (
                    <Form className="quiz-user-form">
                        <CheckboxGroup
                            className="quiz-question-group"
                            label={question.question}
                            questionCount={`${question.order}/${totalQuestions}`}
                        >
                            <Row className="question-container">
                                <Col lg={10}>
                                    <div className="text-center">
                                        {
                                            question.image && <Row>
                                                <Col lg={10}>
                                                    <img src={getEncodedImageUrl(question.image, 500, 400, "contain", {
                                                        r: 215,
                                                        g: 216,
                                                        b: 217,
                                                        alpha: 1
                                                    })} alt={question.question}/>
                                                    <br/><br/>
                                                </Col>
                                            </Row>
                                        }
                                    </div>
                                    <div className="answers-container">
                                        {
                                            question.options.map((option, i) => (
                                                <div key={option.id} className="answers-row">
                                                    <Row className="align-items-center"
                                                         key={`${question.id}-${option.id}`}>
                                                        <Col lg={10}>
                                                            <div className="btn-pos">
                                                                <Field
                                                                    component={CheckBox}
                                                                    alphabet={String.fromCharCode(i + 97)}
                                                                    name={`${question.id}#${option.id}`}
                                                                    id={`${question.id}#${option.id}`}
                                                                    // label={option.label}
                                                                    label={option.option}
                                                                    show_quiz={show_quiz && question.responses.length === 0}
                                                                    bgColor={show_results && (question.responses[0].options.find((qor) => qor.question_option_id === option.id) ? 'light' : 'dark')}
                                                                />
                                                                {show_results &&
                                                                    <div className="ans-status-img">{option.correct ?
                                                                        <img src="/icons/ans-correct.svg"
                                                                             alt="correct"/> :
                                                                        <img src="/icons/wrong-ans.svg"
                                                                             alt="wrong"/>}</div>}
                                                                {
                                                                    show_quiz && (question.responses.length === 0) && (i + 1 === question.options.length) ?
                                                                        <Button color="primary" className="btn-submit"
                                                                                type="submit"
                                                                                disabled={submitting}>{intl.formatMessage({id: 'quiz.send.answer'})}
                                                                            <img src="/icons/send-ans-ico.svg" alt=""/></Button>
                                                                        : null
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col className="indi-votes-container" lg={2}>
                                                            {
                                                                // show_results &&
                                                                // <div className="indi-votes">
                                                                //   <strong>{option.question_option_responses_aggregate.aggregate.count}</strong> votes
                                                                // </div>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </Col>
                                {/* <Col className="total-votes-col-cont" lg={2}>
                  <div className="text-right total-votes-cont">
                    {
                      show_results &&
                      <div className="total-votes">
                        <strong>{
                          question.question_responses_aggregate.aggregate.count
                        }</strong> votes
                      </div>
                    }
                  </div>
                </Col> */}
                            </Row>
                        </CheckboxGroup>
                    </Form>
                )
            }}
        </Formik>
    )
}

export default QuizResultUserForm;
